import imageCompression from 'browser-image-compression';

// Tuned for property photos: long edge ≤ 1600px keeps detail sharp while
// dropping a typical 5–8 MB phone photo to a few hundred KB. WebP is preferred
// (smaller at same quality) when the browser's canvas supports it.

const TARGET_LONG_EDGE = 1600;
const QUALITY          = 0.8;
const MAX_MB           = 0.6;

function supportsWebP() {
  try {
    const canvas = document.createElement('canvas');
    canvas.width = 1; canvas.height = 1;
    return canvas.toDataURL('image/webp').startsWith('data:image/webp');
  } catch {
    return false;
  }
}

const PREFER_WEBP = typeof window !== 'undefined' && supportsWebP();

export async function compressListingPhoto(file) {
  if (!file || !file.type?.startsWith('image/')) return file;
  // Skip already-small files — overhead isn't worth it.
  if (file.size <= 250 * 1024) return file;

  try {
    return await imageCompression(file, {
      maxSizeMB:           MAX_MB,
      maxWidthOrHeight:    TARGET_LONG_EDGE,
      initialQuality:      QUALITY,
      useWebWorker:        true,
      fileType:            PREFER_WEBP ? 'image/webp' : undefined,
      alwaysKeepResolution: false,
    });
  } catch (err) {
    console.warn('[imageCompress] falling back to original:', err);
    return file;
  }
}

export function compressedExt(file) {
  const t = file?.type || '';
  if (t === 'image/webp') return 'webp';
  if (t === 'image/jpeg') return 'jpg';
  if (t === 'image/png')  return 'png';
  const name = file?.name || '';
  const dot  = name.lastIndexOf('.');
  return dot >= 0 ? name.slice(dot + 1) : 'jpg';
}
